import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import {
  Container,
  Grid,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { yupResolver } from '@hookform/resolvers/yup';
import { titleCaseWord } from '../../../utils/stringUtils';
import { styles } from './styles';
import {
  Credentials,
  credentialsSchema,
} from '../../../components/react-hook-forms/grouped/admin/credentials/Credentials';
import {
  Maintenance,
  maintenanceSchema,
  maintenanceDefaults,
  maintenanceFormFields,
} from '../../../components/react-hook-forms/grouped/admin/maintenance/Maintenance';

const LoginInfo = props => {
  const {
    maintenance = false,
    maintenanceEnabled = false,
    submitAction,
    status = '',
    customMessage = '',
  } = props;

  const theme = useTheme();
  const sx = styles(theme);
  const [formStatus, setFormStatus] = useState('');
  const [displayMessage, setDisplayMessage] = useState('');

  const defaultValues = {
    ...maintenanceDefaults,
  };

  const validationSchema = useMemo(
    () => yup
      .object()
      .concat(maintenanceSchema())
      .concat(credentialsSchema()),
    [],
  );

  const formMethods = useForm({
    resolver: yupResolver(validationSchema, { abortEarly: false }),
    mode: 'onBlur',
    defaultValues,
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  });

  const {
    handleSubmit,
    control,
    setValue,
  } = formMethods;

  useEffect(() => {
    setValue(
      maintenanceFormFields.maintenance.name,
      titleCaseWord(maintenanceEnabled),
    );
  }, [maintenanceEnabled, setValue]);

  useEffect(() => {
    setFormStatus(status);
    if (status.length > 0) {
      if (customMessage) {
        setDisplayMessage(customMessage);
      } else if (status === 'failed') {
        setDisplayMessage('Invalid Credentials!! Try again');
      } else {
        setDisplayMessage('Login Success!!');
      }
    }
  }, [status, customMessage]);

  const onPageSubmit = data => {
    setDisplayMessage('');
    setFormStatus('');
    submitAction(data);
  };

  return (
    <div>
      <Container
        id="adminLogin"
        sx={sx.root}
        control={control}
        component="main"
        data-cy="logn-info-container"
      >
        <Grid
          container
          direction="row"
          sx={{
            ...sx.container,
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        >
          {' '}
          <Grid size={{ sm: 6 }} sx={sx.gridTwo}>
            <FormProvider {...formMethods}>
              <form
                onSubmit={handleSubmit(onPageSubmit)}
              >
                {maintenance && <Maintenance sx={sx} control={control} /> }
                <Credentials
                  title="Enter your admin credentials"
                  classes={sx}
                  status={formStatus}
                  statusMessage={displayMessage}
                />
              </form>
            </FormProvider>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

LoginInfo.propTypes = {
  maintenance: PropTypes.bool,
  maintenanceEnabled: PropTypes.bool,
  submitAction: PropTypes.func.isRequired,
  status: PropTypes.string,
  customMessage: PropTypes.string,
};

export default LoginInfo;
